/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, NavItem, NavLink } from "reactstrap";

function DarkFooter() {
  return (
    <footer className="footer" data-background-color="black">
      <Container>
        <nav>
          <ul>
            <li>
              <a href="/over-ons">Over ons</a>
            </li>
          </ul>
        </nav>
        <div className="copyright" id="copyright">
          © {new Date().getFullYear()}, Senteurs du Ciel
        </div>
      </Container>
    </footer>
  );
}

export default DarkFooter;
